import React from "react";
import { useIntl } from "react-intl";

export default function SportCalendar() {
  const intl = useIntl();

  return (
    <>
      <div>{intl.formatMessage({ id: "navbar.sportCalendar" })}</div>
    </>
  );
}
